import type { FC, ReactNode } from "react";

import {
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger
} from "@/components/ui/context-menu";
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger
} from "@/components/ui/dropdown-menu";

/**
 * The row menu renders twice: once as a right-click menu, once as the
 * three-dot menu. Both families accept the props the items actually use.
 */
export type MenuKit = {
  Item: FC<{
    onSelect?: () => void;
    disabled?: boolean;
    variant?: "default" | "destructive";
    title?: string;
    className?: string;
    children?: ReactNode;
    "data-testid"?: string;
  }>;
  Separator: FC;
  Sub: FC<{ children?: ReactNode }>;
  SubTrigger: FC<{ disabled?: boolean; children?: ReactNode }>;
  SubContent: FC<{ className?: string; children?: ReactNode }>;
};

export const dropdownMenuKit: MenuKit = {
  Item: DropdownMenuItem,
  Separator: DropdownMenuSeparator,
  Sub: DropdownMenuSub,
  SubTrigger: DropdownMenuSubTrigger,
  SubContent: DropdownMenuSubContent
};

export const contextMenuKit: MenuKit = {
  Item: ContextMenuItem as unknown as MenuKit["Item"],
  Separator: ContextMenuSeparator,
  Sub: ContextMenuSub,
  SubTrigger: ContextMenuSubTrigger as unknown as MenuKit["SubTrigger"],
  SubContent: ContextMenuSubContent
};
